import * as Avatar from "@radix-ui/react-avatar";
import cx from "classnames";

import { ReactComponent as PunttMark } from "../../../images/PunttMark.svg";

/**
 * Circular Puntt avatar sized like `AvatarWithInitials` (size × 4 px).
 * Solid brand-blue disc with the white P mark — not the hex app-icon asset.
 */
export function PunttAvatar({
  size = 8,
  className = "",
  "data-testid": dataTestId = "puntt-avatar",
}: {
  size?: number;
  className?: string;
  "data-testid"?: string;
}) {
  return (
    <Avatar.Root
      aria-hidden="true"
      className={cx(
        "inline-flex aspect-square shrink-0 select-none items-center justify-center overflow-hidden rounded-full bg-puntt-blue-9 text-base-white",
        className,
      )}
      style={{ height: size * 4 }}
      data-testid={dataTestId}
    >
      <PunttMark className="size-[58%] shrink-0" aria-hidden="true" />
    </Avatar.Root>
  );
}
